<script lang="ts">
  import type { FormOption } from "../types";
  import Label from "./Label.svelte";

  export let label: string;
  export let options: FormOption<unknown>[];
  export let value: unknown = null;

  const id = crypto.randomUUID();
</script>

<div class="Select">
  <Label {id}>
    {label}
  </Label>
  <select class="Select-input" {id} bind:value on:change>
    <option disabled selected />
    {#each options as option}
      <option value={option.value}>{option.label}</option>
    {/each}
  </select>
</div>

<style>
  .Select-input {
    appearance: none;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'><path d='M.293.293a1 1 0 0 1 1.414 0L5 3.586 8.293.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z' fill='hsl(214 100% 17%)'/></svg>");
    background-position: right var(--size-18) center;
    background-repeat: no-repeat;
    background-size: var(--size-10);
    border: var(--size-1) solid var(--color-gray-border);
    border-radius: var(--size-20);
    color: var(--color-blue);
    padding-block: var(--size-8);
    padding-inline: var(--size-18) var(--size-40);
  }
</style>
